import React, { useState, useEffect } from "react";

const FONT_OPTIONS = [
  "Inter", "Roboto", "Open Sans", "Lato", "Montserrat", "Poppins", "Source Sans Pro",
  "Raleway", "Merriweather", "Nunito", "Ubuntu", "PT Sans", "Work Sans", "Rubik",
  "Quicksand", "Karla", "Fira Sans", "Oxygen", "Noto Sans", "Arimo"
];

export default function Branding() {
  const [bannerPreview, setBannerPreview] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [headerColor, setHeaderColor] = useState("#fa8128");
  const [buttonColor, setButtonColor] = useState("#000080");
  const [selectedFont, setSelectedFont] = useState("Inter");

  useEffect(() => {
    const storedBanner = localStorage.getItem("banner");
    const storedLogo = localStorage.getItem("logo");
    const storedTheme = JSON.parse(localStorage.getItem("theme"));
    const storedFont = localStorage.getItem("font");

    if (storedBanner) setBannerPreview(storedBanner);
    if (storedLogo) setLogoPreview(storedLogo);
    if (storedTheme) {
      setHeaderColor(storedTheme.primary);
      setButtonColor(storedTheme.secondary);
    }
    if (storedFont) setSelectedFont(storedFont);
  }, []);

  const handleImageUpload = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      if (type === "banner") {
        localStorage.setItem("banner", reader.result);
        setBannerPreview(reader.result);
      } else {
        localStorage.setItem("logo", reader.result);
        setLogoPreview(reader.result);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleThemeChange = () => {
    localStorage.setItem("theme", JSON.stringify({ primary: headerColor, secondary: buttonColor }));
    localStorage.setItem("font", selectedFont);
    window.location.reload();
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold mb-6">Branding Settings</h2>

      {/* Logo Upload */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Upload Logo (top-left)
        </label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => handleImageUpload(e, "logo")}
          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200"
        />
        {logoPreview && (
          <img src={logoPreview} alt="Logo Preview" className="mt-4 h-16 object-contain" />
        )}
      </div>

      {/* Banner Upload */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">Dashboard Banner Image</label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => handleImageUpload(e, "banner")}
          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200"
        />
        <p className="text-xs text-gray-400 mt-1">Recommended size: 1200 x 300 px</p>
        {bannerPreview && (
          <div className="mt-4">
            <img
              src={bannerPreview}
              alt="Banner Preview"
              className="w-full h-40 object-cover rounded-lg border"
            />
          </div>
        )}
      </div>

      {/* Theme Colors */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Header Colour</label>
          <input
            type="color"
            value={headerColor}
            onChange={(e) => setHeaderColor(e.target.value)}
            className="w-full h-10 border rounded"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Button/Text Colour</label>
          <input
            type="color"
            value={buttonColor}
            onChange={(e) => setButtonColor(e.target.value)}
            className="w-full h-10 border rounded"
          />
        </div>
      </div>

      {/* Font Selector */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">Font</label>
        <select
          value={selectedFont}
          onChange={(e) => setSelectedFont(e.target.value)}
          className="w-full p-2 border rounded"
        >
          {FONT_OPTIONS.map((font) => (
            <option key={font} value={font}>{font}</option>
          ))}
        </select>
      </div>

      <button
        onClick={handleThemeChange}
        className="bg-blue-600 text-white px-6 py-2 rounded-full hover:bg-blue-700"
      >
        Save Changes
      </button>
    </div>
  );
}
